import React from 'react'
import style from './style.module.scss'

type burgerHeaderProps = {
    setActive: any
}

const BurgerHeader: React.FC<burgerHeaderProps> = ({ setActive }) => {
    return (
        <div className={style.burger} onClick={() => setActive((prev) => !prev)}>
            <div className={style.container}>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    )
}

export default BurgerHeader
